import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { TokenRefreshOverlay } from '@onesource/components';
import { Suspense } from 'react';
import { SHOW_DEV_TOOLS } from '../config';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <Suspense>
      <TokenRefreshOverlay />
      <Outlet />
      {SHOW_DEV_TOOLS && <TanStackRouterDevtools />}
    </Suspense>
  ),
});
